<!-- Detail View Mode (when "See more" is clicked on bid item popup) -->
@if (detailViewMode === 'bid_item') {
  <div class="detail-view-container">
    <div class="detail-view-header">
      <div class="detail-view-header-content">
        <div class="bid-item-number">Bid item {{ detailViewData?.data?.bid_item?.item }}</div>
        <div class="chips-row">
          @if (detailViewData?.data?.siteName) {
            <div class="site-chip">
              <span class="chip-text">{{ detailViewData?.data?.siteName }}</span>
            </div>
          }
          @if (detailViewData?.data?.reportDate) {
            <div class="date-chip">
              <span class="chip-text">{{ detailViewData?.data?.reportDate | date: 'MMM d, yyyy' }}</span>
            </div>
          }
        </div>
      </div>
      <button class="close-button" (click)="closeDetailView()" [attr.aria-label]="'Close detail view'">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 5L5 15M5 5L15 15" stroke="#060B1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
    @if (spatialSummaryState) {
      <div class="detail-view-spatial-summary">
        <ng-container *ngTemplateOutlet="spatialSummaryTpl" />
      </div>
    } @else {
      <app-map-sidenav-bid-item-wrapper
        [data]="detailViewData?.data"
        [highlightLineItemId]="detailViewData?.highlightLineItemId"
        [highlightFeatureIndex]="detailViewData?.highlightFeatureIndex"
        />
    }
  </div>
}

<!-- Activity Detail View Mode (when "See more" is clicked on activity popup) -->
@if (detailViewMode === 'activity') {
  <div class="detail-view-container">
    <div class="detail-view-header">
      <div class="detail-view-header-content">
        <div class="bid-item-number">Activity</div>
        <div class="chips-row">
          @if (detailViewData?.data?.siteName) {
            <div class="site-chip">
              <span class="chip-text">{{ detailViewData?.data?.siteName }}</span>
            </div>
          }
          @if (detailViewData?.data?.reportDate) {
            <div class="date-chip">
              <span class="chip-text">{{ detailViewData?.data?.reportDate | date: 'MMM d, yyyy' }}</span>
            </div>
          }
        </div>
      </div>
      <button class="close-button" (click)="closeDetailView()" [attr.aria-label]="'Close detail view'">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 5L5 15M5 5L15 15" stroke="#060B1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
    <app-activity-item-details
      [data]="detailViewData?.data"
      [options]="{ showActionsSection: false, disabled: true, showHeading: false }"
      />
  </div>
}

<!-- Delivery Detail View Mode (when "See more" is clicked on delivery popup) -->
@if (detailViewMode === 'delivery') {
  <div class="detail-view-container">
    <div class="detail-view-header">
      <div class="detail-view-header-content">
        <div class="bid-item-number">Delivery</div>
        <div class="chips-row">
          @if (detailViewData?.data?.siteName) {
            <div class="site-chip">
              <span class="chip-text">{{ detailViewData?.data?.siteName }}</span>
            </div>
          }
          @if (detailViewData?.data?.reportDate) {
            <div class="date-chip">
              <span class="chip-text">{{ detailViewData?.data?.reportDate | date: 'MMM d, yyyy' }}</span>
            </div>
          }
        </div>
      </div>
      <button class="close-button" (click)="closeDetailView()" [attr.aria-label]="'Close detail view'">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 5L5 15M5 5L15 15" stroke="#060B1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
    <app-delivery-details
      [data]="detailViewData?.data"
      [showHeading]="false"
      />
  </div>
}

<!-- Control Form Detail View Mode (when "See more" is clicked on form popup) -->
@if (detailViewMode === 'forms') {
  <div class="detail-view-container">
    <div class="detail-view-header">
      <div class="detail-view-header-content">
        <div class="bid-item-number">{{ detailViewData?.data?.name || 'Form' }}</div>
        <div class="chips-row">
          @if (detailViewData?.data?.siteName) {
            <div class="site-chip">
              <span class="chip-text">{{ detailViewData?.data?.siteName }}</span>
            </div>
          }
          @if (detailViewData?.data?.reportDate) {
            <div class="date-chip">
              <span class="chip-text">{{ detailViewData?.data?.reportDate | date: 'MMM d, yyyy' }}</span>
            </div>
          }
        </div>
      </div>
      <button class="close-button" (click)="closeDetailView()" [attr.aria-label]="'Close detail view'">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 5L5 15M5 5L15 15" stroke="#060B1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
    <div class="form-detail-body">
      <!-- Reuse the real control-forms detail component in read-only mode so the
           map drilldown stays in parity with the content-outlet form panel.
           Keyed by form id via @for so switching from one form marker to another
           (detailViewMode stays 'forms') DESTROYS + recreates the component — it
           hydrates only in ngOnInit, so a reused instance would show the previous
           form's fields/lines/template. -->
      @for (formId of [detailViewData?.data?.id]; track formId) {
        <app-control-forms-details
          [data]="detailViewData?.data"
          [options]="{ disabled: true }"
          />
      }
    </div>
  </div>
}

<!-- Normal View Mode (default sidenav) -->
@if (detailViewMode === 'none') {
  <div class="map-sidenav-container">
    <!-- Project Header -->
    <div class="sidenav-header">
      <h2 class="project-name" [matTooltip]="projectName" matTooltipPosition="below" matTooltipClass="project-name-tooltip">{{ projectName }}</h2>
      <div class="header-actions">
        <!-- Filter icon button (always visible) -->
        <button
          #filtersIconButton="cdkOverlayOrigin"
          cdkOverlayOrigin
          class="icon-button"
          (click)="onFiltersClick('icon')"
          [attr.aria-label]="'Toggle filters'">
          <mat-icon svgIcon="map-filters"></mat-icon>
        </button>
        <div class="calendar-button-wrapper">
          <button class="icon-button" (click)="onCalendarClick()" [attr.aria-label]="'Open calendar'">
            <mat-icon svgIcon="map-calendar"></mat-icon>
          </button>
          <!-- Hidden date range picker (triggered by calendar button) - for normal mode -->
          @if (!isSingleDayMode) {
            <form [formGroup]="dateRangeForm" class="hidden-date-picker">
              <mat-form-field>
                <mat-date-range-input [rangePicker]="dateRangePicker">
                  <input formControlName="startDate" matStartDate />
                  <input formControlName="endDate" matEndDate />
                </mat-date-range-input>
                <mat-date-range-picker #dateRangePicker [calendarHeaderComponent]="calendarHeader"></mat-date-range-picker>
              </mat-form-field>
            </form>
          }
          <!-- Hidden single date picker (triggered by calendar button) - for single day mode -->
          @if (isSingleDayMode) {
            <div class="hidden-date-picker">
              <mat-form-field>
                <input matInput [matDatepicker]="singleDatePicker" [formControl]="singleDateControl" />
                <mat-datepicker #singleDatePicker [calendarHeaderComponent]="calendarHeader"></mat-datepicker>
              </mat-form-field>
            </div>
          }
        </div>
        <button
          #viewButton="cdkOverlayOrigin"
          cdkOverlayOrigin
          class="icon-button"
          (click)="onViewClick()"
          [attr.aria-label]="'Change view'">
          <mat-icon svgIcon="map-view"></mat-icon>
        </button>
      </div>
    </div>
    <!-- Active Filters Chips (hide in single day mode) -->
    @if (!isSingleDayMode && getActiveFilterCount() > 0) {
      <div class="sidenav-section active-filters-section">
        <button
          #filtersChipButton="cdkOverlayOrigin"
          cdkOverlayOrigin
          class="filter-chip"
          (click)="onFiltersClick('chip')"
          [attr.aria-label]="'Toggle filters'">
          <span class="filter-chip-text">Filter ({{ getActiveFilterCount() }})</span>
          <mat-icon svgIcon="map-filters"></mat-icon>
        </button>
      </div>
    }
    <!-- Single Date Display (for single day mode) -->
    @if (isSingleDayMode) {
      <div class="sidenav-section single-date-section">
        <div class="single-date-display">
          <span class="date-label">{{ selectedDate | date: 'MMMM d, yyyy' }}</span>
        </div>
      </div>
    }
    <!-- Timeline Slider Section (hide in single day mode) -->
    @if (!isSingleDayMode) {
      <div class="sidenav-section timeline-slider-section">
        <div class="timeline-slider-container">
          <!-- Date range label and controls -->
          <div class="timeline-header">
            <span class="date-range-label">{{ getFormattedDateRange() }}</span>
            <div class="timeline-controls">
              <button class="timeline-control-button" (click)="onTimelinePrevious()" [attr.aria-label]="'Previous period'">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.3333 17.5L5.83331 10L13.3333 2.5" stroke="#060B1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <button class="timeline-control-button" (click)="onTimelinePlay()" [attr.aria-label]="isPlaying ? 'Pause timeline' : 'Play timeline'">
                <!-- Play icon (shown when not playing) -->
                @if (!isPlaying) {
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.16669 1.33594L19.1667 10.0026L4.16669 18.6693V1.33594Z" stroke="#060B1E" stroke-width="2" stroke-linejoin="round"/>
                  </svg>
                }
                <!-- Pause icon (shown when playing) -->
                @if (isPlaying) {
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="5" y="3" width="3" height="14" fill="#060B1E"/>
                    <rect x="12" y="3" width="3" height="14" fill="#060B1E"/>
                  </svg>
                }
              </button>
              <!-- Speed control - hidden for now, may revisit later
              <button class="timeline-speed-badge" (click)="onSpeedCycle()" [attr.aria-label]="'Playback speed: ' + playbackSpeed + 'x'">
                {{ playbackSpeed }}x
              </button>
              -->
              <button class="timeline-control-button" (click)="onTimelineNext()" [attr.aria-label]="'Next period'">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.66669 2.5L14.1667 10L6.66669 17.5" stroke="#060B1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
          <!-- Slider track -->
          <div class="timeline-slider-track-container">
            <div class="timeline-slider-track">
              <div class="track-background"></div>
              <div class="track-filled" [style.left.%]="getSliderStartPercent()" [style.width.%]="getSliderWidthPercent()"></div>
              <div
                class="track-selected"
                [style.left.%]="getSliderStartPercent()"
                [style.width.%]="getSliderWidthPercent()"
                [style.cursor]="dragHandle === 'range' ? 'grabbing' : 'grab'"
                (mousedown)="onSliderRangeMouseDown($event)"
                (touchstart)="onSliderRangeMouseDown($event)">
              </div>
              <div
                class="slider-handle slider-handle-start"
                [style.left.%]="getSliderStartPercent()"
                (mousedown)="onSliderHandleMouseDown($event, 'start')"
                (touchstart)="onSliderHandleMouseDown($event, 'start')">
              </div>
              <div
                class="slider-handle slider-handle-end"
                [style.left.%]="getSliderEndPercent()"
                (mousedown)="onSliderHandleMouseDown($event, 'end')"
                (touchstart)="onSliderHandleMouseDown($event, 'end')">
              </div>
            </div>
          </div>
          <!-- Month labels -->
          <div class="timeline-labels">
            @for (month of getTimelineMonths(); track month) {
              <span class="timeline-label">{{ month }}</span>
            }
          </div>
        </div>
      </div>
    }
    <!-- Spatial Summary Section — takes over the list area when the user is
         drawing a polygon via the map widgets toolbar. -->
    @if (spatialSummaryState) {
      <ng-container *ngTemplateOutlet="spatialSummaryTpl" />
    }
    <!-- Sites List Section (shown when View By Site is selected) -->
    @if (!spatialSummaryState && selectedViewBy === 'site') {
      <div class="sidenav-section sites-list-section">
        <div class="sites-list-header">
          <span>{{ getSitesCount() }} sites</span>
          @if (selectedSiteIdsForHighlight.size > 0) {
            <button
              class="clear-selection-btn"
              matTooltip="Clear"
              matTooltipPosition="right"
              matTooltipClass="small-tooltip white-tooltip"
              (click)="clearSiteSelections()">
              <mat-icon>clear_all</mat-icon>
            </button>
          }
        </div>
        <div class="sites-list">
          @for (site of filteredSitesForView; track site; let i = $index) {
            <div
              class="site-list-item"
              [class.selected]="isSiteSelected(site.site_id || site.id)"
              (click)="onSiteClick(site.site_id || site.id)"
              (mouseenter)="onSiteHover(site.site_id || site.id)"
              (mouseleave)="onSiteHover(null)">
              <span class="site-name">{{ site.site_name || site.name }}</span>
              <div class="color-square" [style.background-color]="getSiteColor(i)"></div>
            </div>
          }
        </div>
      </div>
    }
    <!-- Bid Items List Section (shown when View By Bid Item is selected) -->
    @if (!spatialSummaryState && selectedViewBy === 'bid_item') {
      <div class="sidenav-section sites-list-section">
        <div class="sites-list-header">
          <span>{{ getBidItemsCount() }} bid items</span>
          @if (selectedBidItemIdsForHighlight.size > 0) {
            <button
              class="clear-selection-btn"
              matTooltip="Clear"
              matTooltipPosition="right"
              matTooltipClass="small-tooltip white-tooltip"
              (click)="clearBidItemSelections()">
              <mat-icon>clear_all</mat-icon>
            </button>
          }
        </div>
        <div class="sites-list">
          @for (bidItem of aggregatedBidItems; track bidItem) {
            <div
              class="site-list-item"
              [class.selected]="isBidItemSelected(bidItem.id)"
              (click)="onBidItemClick(bidItem.id)"
              (mouseenter)="onBidItemHover(bidItem.id)"
              (mouseleave)="onBidItemHover(null)">
              <span class="site-name">{{ bidItem.item }} - {{ bidItem.description | sentenceCase }}</span>
              <div class="color-square" [style.background-color]="bidItem.color"></div>
            </div>
          }
        </div>
      </div>
    }
    <!-- Inspectors List Section (shown when View By Inspector is selected) -->
    @if (!spatialSummaryState && selectedViewBy === 'inspector') {
      <div class="sidenav-section sites-list-section">
        <div class="sites-list-header">
          <span>{{ getInspectorsCount() }} inspectors</span>
          @if (selectedInspectorIdsForHighlight.size > 0) {
            <button
              class="clear-selection-btn"
              matTooltip="Clear"
              matTooltipPosition="right"
              matTooltipClass="small-tooltip white-tooltip"
              (click)="clearInspectorSelections()">
              <mat-icon>clear_all</mat-icon>
            </button>
          }
        </div>
        <div class="sites-list">
          @for (inspector of aggregatedInspectors; track inspector) {
            <div
              class="site-list-item"
              [class.selected]="isInspectorSelected(inspector.id)"
              (click)="onInspectorClick(inspector.id)"
              (mouseenter)="onInspectorHover(inspector.id)"
              (mouseleave)="onInspectorHover(null)">
              <span class="site-name">{{ inspector.name }}</span>
              <div class="color-square" [style.background-color]="inspector.color"></div>
            </div>
          }
        </div>
      </div>
    }
    <!-- Dates List Section (shown when View By Day is selected) -->
    @if (!spatialSummaryState && selectedViewBy === 'day') {
      <div class="sidenav-section sites-list-section">
        <div class="sites-list-header">
          <span>{{ getDatesCount() }} days</span>
          @if (selectedDatesForHighlight.size > 0) {
            <button
              class="clear-selection-btn"
              matTooltip="Clear"
              matTooltipPosition="right"
              matTooltipClass="small-tooltip white-tooltip"
              (click)="clearDateSelections()">
              <mat-icon>clear_all</mat-icon>
            </button>
          }
        </div>
        <div class="sites-list">
          @for (dateItem of aggregatedDates; track dateItem) {
            <div
              class="site-list-item"
              [class.selected]="isDateSelected(dateItem.date)"
              (click)="onDateClick(dateItem.date)"
              (mouseenter)="onDateHover(dateItem.date)"
              (mouseleave)="onDateHover(null)">
              <span class="site-name">{{ dateItem.displayDate }}</span>
              <div class="color-square" [style.background-color]="dateItem.color"></div>
            </div>
          }
        </div>
      </div>
    }
    <!-- Filters Dropdown -->
    <ng-template
      (backdropClick)="showFiltersOverlay = false"
      [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
      [cdkConnectedOverlayHasBackdrop]="true"
      [cdkConnectedOverlayOpen]="showFiltersOverlay"
      [cdkConnectedOverlayOrigin]="filtersOverlayOrigin === 'chip' ? filtersChipButton : filtersIconButton"
      cdkConnectedOverlay
      >
      <div class="filters-dropdown">
        <mat-tab-group>
          <!-- Hide Site tab if project has only 1 site or in single day mode -->
          @if (!hasSingleSite && !isSingleDayMode) {
            <mat-tab label="Site">
              <div class="filter-tab-content">
                <div class="search-container">
                  <mat-icon svgIcon="search" class="search-icon"></mat-icon>
                  <input
                    type="text"
                    class="search-input"
                    placeholder="Search for site"
                    [value]="searchQuery"
                    (input)="onSearchInput($any($event.target).value)"
                    />
                </div>
                <div class="filter-items-list">
                  <div class="filter-item" (click)="toggleFilter('site', 'all')">
                    <div class="checkbox" [class.checked]="isSiteFilterChecked('all')">
                      @if (isSiteFilterChecked('all')) {
                        <svg class="check-icon" width="10" height="9" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 6.61963L4.62751 10L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      }
                    </div>
                    <span class="filter-label bold">All</span>
                  </div>
                  @for (item of getFilteredSites(); track item) {
                    <div class="filter-item" (click)="toggleFilter('site', item.id)">
                      <div class="checkbox" [class.checked]="isSiteFilterChecked(item.id)">
                        @if (isSiteFilterChecked(item.id)) {
                          <svg class="check-icon" width="10" height="9" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 6.61963L4.62751 10L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        }
                      </div>
                      <span class="filter-label">{{ item.label }}</span>
                    </div>
                  }
                </div>
              </div>
            </mat-tab>
          }
          <mat-tab label="Bid item">
            <div class="filter-tab-content">
              <div class="search-container">
                <mat-icon svgIcon="search" class="search-icon"></mat-icon>
                <input
                  type="text"
                  class="search-input"
                  placeholder="Search for bid item"
                  [value]="searchQuery"
                  (input)="onSearchInput($any($event.target).value)"
                  />
              </div>
              <div class="filter-items-list">
                <div class="filter-item" (click)="toggleFilter('bidItem', 'all')">
                  <div class="checkbox" [class.checked]="isBidItemFilterChecked('all')">
                    @if (isBidItemFilterChecked('all')) {
                      <svg class="check-icon" width="10" height="9" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 6.61963L4.62751 10L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    }
                  </div>
                  <span class="filter-label bold">All</span>
                </div>
                @for (item of getFilteredBidItems(); track item) {
                  <div class="filter-item" (click)="toggleFilter('bidItem', item.id)">
                    <div class="checkbox" [class.checked]="isBidItemFilterChecked(item.id)">
                      @if (isBidItemFilterChecked(item.id)) {
                        <svg class="check-icon" width="10" height="9" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 6.61963L4.62751 10L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      }
                    </div>
                    <span class="filter-label">{{ item.item }} - {{ item.description | sentenceCase }}</span>
                  </div>
                }
              </div>
            </div>
          </mat-tab>
          <!-- TODO: Add Pay app filter tab later -->
          <!--<mat-tab label="Pay app">
          <div class="filter-tab-content">
            <div class="search-container">
              <mat-icon svgIcon="search" class="search-icon"></mat-icon>
              <input
                type="text"
                class="search-input"
                placeholder="Search for pay app"
                [(ngModel)]="searchQuery"
                />
            </div>
            <div class="filter-items-list">
              <div class="filter-item" (click)="toggleFilter('payApp', 'all')">
                <div class="checkbox" [class.checked]="isPayAppFilterChecked('all')">
                  <svg *ngIf="isPayAppFilterChecked('all')" class="check-icon" width="10" height="9" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 6.61963L4.62751 10L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <span class="filter-label bold">All</span>
              </div>
              <div class="filter-item" *ngFor="let item of getFilteredPayApps()" (click)="toggleFilter('payApp', item.id)">
                <div class="checkbox" [class.checked]="isPayAppFilterChecked(item.id)">
                  <svg *ngIf="isPayAppFilterChecked(item.id)" class="check-icon" width="10" height="9" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 6.61963L4.62751 10L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <span class="filter-label">{{ item.label }}</span>
              </div>
            </div>
          </div>
        </mat-tab>-->
      </mat-tab-group>
    </div>
  </ng-template>
  <!-- View By Dropdown (with Color by, Layers, Types tabs) -->
  <ng-template
    (backdropClick)="showViewOverlay = false"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayOpen]="showViewOverlay"
    [cdkConnectedOverlayOrigin]="viewButton"
    cdkConnectedOverlay
    >
    <div class="view-dropdown" [class.with-design]="showDesignTab">
      <mat-tab-group [(selectedIndex)]="viewTabIndex">
        <!-- Color by tab -->
        <mat-tab label="Color by">
          <div class="view-tab-content">
            <div class="color-by-options">
              <div class="color-option" [class.active]="selectedViewBy === 'site'" (click)="onViewBySelect('site')">
                Site
              </div>
              <div class="color-option" [class.active]="selectedViewBy === 'bid_item'" (click)="onViewBySelect('bid_item')">
                Bid Item
              </div>
              @if (!isSingleDayMode) {
                <div class="color-option" [class.active]="selectedViewBy === 'day'" (click)="onViewBySelect('day')">
                  Day
                </div>
              }
              <div class="color-option" [class.active]="selectedViewBy === 'inspector'" (click)="onViewBySelect('inspector')">
                Inspector
              </div>
            </div>
          </div>
        </mat-tab>
        <!-- Layers tab -->
        <mat-tab label="Layers">
          <div class="view-tab-content">
            <div class="layer-options">
              <div class="layer-option" (click)="onLayerToggle('siteBoundary')">
                <div class="checkbox" [class.checked]="selectedLayers.siteBoundary">
                  @if (selectedLayers.siteBoundary) {
                    <svg class="check-icon" width="10" height="9" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 6.61963L4.62751 10L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  }
                </div>
                <span class="layer-label">Sites</span>
              </div>
              <div class="layer-option" (click)="onLayerToggle('asBuilt')">
                <div class="checkbox" [class.checked]="selectedLayers.asBuilt">
                  @if (selectedLayers.asBuilt) {
                    <svg class="check-icon" width="10" height="9" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 6.61963L4.62751 10L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  }
                </div>
                <span class="layer-label">As-builts</span>
              </div>
              <div class="layer-option" (click)="onLayerToggle('picture')">
                <div class="checkbox" [class.checked]="selectedLayers.picture">
                  @if (selectedLayers.picture) {
                    <svg class="check-icon" width="10" height="9" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 6.61963L4.62751 10L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  }
                </div>
                <span class="layer-label">Pictures</span>
              </div>
            </div>
          </div>
        </mat-tab>
        <!-- Types tab -->
        <mat-tab label="Types">
          <div class="view-tab-content">
            <div class="type-options">
              @for (typeFilter of typeFilters; track typeFilter) {
                <div class="type-option"
                  (click)="toggleTypeFilter(typeFilter.id)">
                  <div class="checkbox" [class.checked]="isTypeFilterChecked(typeFilter.id)">
                    @if (isTypeFilterChecked(typeFilter.id)) {
                      <svg class="check-icon" width="10" height="9" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 6.61963L4.62751 10L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    }
                  </div>
                  <div class="type-icon-container">
                    <mat-icon [svgIcon]="typeFilter.icon" class="type-icon"></mat-icon>
                  </div>
                  <span class="type-label">{{ typeFilter.label }}</span>
                </div>
              }
              @if (linkedOnlyAvailable) {
                <div class="type-option" data-testid="linked-only-filter" role="checkbox" tabindex="0"
                  [attr.aria-checked]="isTypeFilterChecked(linkedOnlyFilter.id)"
                  (click)="toggleTypeFilter(linkedOnlyFilter.id)"
                  (keydown.enter)="toggleTypeFilter(linkedOnlyFilter.id)"
                  (keydown.space)="$event.preventDefault(); toggleTypeFilter(linkedOnlyFilter.id)">
                  <div class="checkbox" [class.checked]="isTypeFilterChecked(linkedOnlyFilter.id)">
                    @if (isTypeFilterChecked(linkedOnlyFilter.id)) {
                      <svg class="check-icon" width="10" height="9" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 6.61963L4.62751 10L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    }
                  </div>
                  <div class="type-icon-container">
                    <mat-icon [svgIcon]="linkedOnlyFilter.icon" class="type-icon"></mat-icon>
                  </div>
                  <span class="type-label">{{ linkedOnlyFilter.label }}</span>
                </div>
              }
            </div>
          </div>
        </mat-tab>
        <!-- Design tab: the project's design layers (plans, utilities, GIS) next to the SiteNotes layers -->
        @if (showDesignTab) {
        <mat-tab>
          <ng-template mat-tab-label>Design@if (designVisibleCount) {<span class="tab-count">{{ designVisibleCount }}</span>}</ng-template>
          <div class="view-tab-content design-tab" data-testid="map-design-tab">
            @if (hasStationing) {
              <!-- 7.2: station ticks and labels along the project's alignments, and the pointer's station; above the design layers -->
              <div class="layer-options">
                <div class="design-row">
                  <div class="layer-option" data-testid="map-layer-stationing" role="checkbox" tabindex="0" [attr.aria-checked]="stationingOn" aria-label="Stationing"
                       (click)="onToggleStationing()" (keydown.enter)="onToggleStationing()" (keydown.space)="onToggleStationing(); $event.preventDefault()">
                    <div class="checkbox" [class.checked]="stationingOn">
                      @if (stationingOn) {
                        <svg class="check-icon" width="10" height="9" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 6.61963L4.62751 10L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      }
                    </div>
                    <span class="layer-label">Stationing</span>
                  </div>
                </div>
              </div>
            }
            @if (projectLayers.overlayLoading) {
              <p class="design-state" role="status">Loading design layers…</p>
            } @else if (projectLayers.overlayError) {
              <p class="design-state" role="alert">{{ projectLayers.overlayError }}</p>
              <button type="button" class="design-link" (click)="projectLayersRetry.emit()">Try again</button>
            } @else if (!projectLayers.overlayLayers.length) {
              <p class="design-state">No design layers on this project yet.@if (canManageLayers) { Add them in Settings &rsaquo; Design layers. }</p>
            } @else {
              @if (projectLayers.overlayLayers.length > 6) {
                <label class="design-search">
                  <mat-icon aria-hidden="true">search</mat-icon>
                  <input type="search" placeholder="Search layers" aria-label="Search design layers" [value]="designSearch" (input)="setDesignSearch($event)" data-testid="map-design-search" />
                </label>
              }
              <div class="layer-options design-list">
                @for (group of designGroups; track group.name) {
                  @if (group.name !== 'Other layers' || designHasGroups) { <h4 class="design-group-name">{{ group.name }}</h4> }
                  @for (entry of group.entries; track entry.id) {
                    <div class="design-row" [attr.data-layer-id]="entry.id">
                      <div class="layer-option" role="checkbox" tabindex="0" [attr.aria-checked]="isDesignVisible(entry.id)" [attr.aria-label]="entry.name"
                           (click)="projectLayerToggle.emit(entry.id)" (keydown.enter)="projectLayerToggle.emit(entry.id)" (keydown.space)="projectLayerToggle.emit(entry.id); $event.preventDefault()">
                        <div class="checkbox" [class.checked]="isDesignVisible(entry.id)">
                          @if (isDesignVisible(entry.id)) {
                            <svg class="check-icon" width="10" height="9" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1 6.61963L4.62751 10L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          }
                        </div>
                        <span class="layer-label">{{ entry.name }}</span>
                        @if (entry.extent) {
                          <button type="button" class="design-icon" (click)="projectLayerZoom.emit(entry.id); $event.stopPropagation()"
                            [attr.aria-label]="'Zoom to ' + entry.name" [title]="'Zoom to ' + entry.name"><mat-icon>zoom_in_map</mat-icon></button>
                        }
                      </div>
                      @if (entry.drawing; as drawing) {
                        <div class="design-drawing">
                          @if (drawing.needsPlacement) { <span class="design-badge" data-testid="map-design-newer-revision">Newer revision issued</span> }
                          <button type="button" class="design-link" (click)="openDrawingSheet(drawing.revisionUuid)" data-testid="map-design-open-sheet">Open sheet</button>
                        </div>
                      }
                      @if (isDesignVisible(entry.id)) {
                        <label class="design-opacity"><span>Opacity <output>{{ opacityPercent(entry.opacity) }}%</output></span>
                          <input type="range" class="sn-range" min="0" max="100" step="1" [value]="opacityPercent(entry.opacity)" (input)="changeDesignOpacity(entry.id, $event)" [style.--fill]="opacityPercent(entry.opacity) + '%'" [attr.aria-label]="entry.name + ' opacity'" /></label>
                        @if (entry.labels !== undefined) {
                          <label class="design-labels"><input type="checkbox" [checked]="entry.labels" (change)="projectLayerLabels.emit(entry.id)" /> Labels</label>
                        }
                        @if (entry.status === 'loading') { <p class="design-state" role="status">Loading layer…</p> }
                        @if (entry.error) { <p class="design-state" role="alert">{{ entry.error }}</p> }
                      }
                    </div>
                  }
                } @empty { <p class="design-state">No layers match your search.</p> }
              </div>
              <div class="design-actions">
                <button type="button" class="design-link" (click)="projectLayersReset.emit()">Reset to project defaults</button>
                <button type="button" class="design-link" [disabled]="!designVisibleCount"
                  [attr.aria-pressed]="projectLayers.swipePreset === 'project-design-vs-asbuilt'"
                  (click)="projectLayerSwipe.emit(projectLayers.swipePreset === 'project-design-vs-asbuilt' ? 'off' : 'project-design-vs-asbuilt')">
                  {{ projectLayers.swipePreset === 'project-design-vs-asbuilt' ? 'Stop comparison' : 'Swipe to compare' }}
                </button>
              </div>
              @if (projectLayers.swipePreset === 'project-design-vs-asbuilt') {
                <p class="design-note">Drag the divider to compare design layers with SiteNotes records.</p>
              }
              <p class="design-note">Visibility and opacity apply only to your view.</p>
            }
          </div>
        </mat-tab>
        }
      </mat-tab-group>
    </div>
  </ng-template>

  <!-- View By Dropdown (with Color by, Layers, Types tabs) -->
  <ng-template
    (backdropClick)="showViewOverlay = false"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayOpen]="showViewOverlay"
    [cdkConnectedOverlayOrigin]="viewButton"
    cdkConnectedOverlay
  >
    <div class="view-dropdown" [class.with-design]="showDesignTab">
      <mat-tab-group [(selectedIndex)]="viewTabIndex">
        <!-- Color by tab -->
        <mat-tab label="Color by">
          <div class="view-tab-content">
            <div class="color-by-options">
              <div class="color-option" [class.active]="selectedViewBy === 'site'" (click)="onViewBySelect('site')">
                Site
              </div>
              <div class="color-option" [class.active]="selectedViewBy === 'bid_item'" (click)="onViewBySelect('bid_item')">
                Bid Item
              </div>
              @if (!isSingleDayMode) {
                <div class="color-option" [class.active]="selectedViewBy === 'day'" (click)="onViewBySelect('day')">
                  Day
                </div>
              }
              <div class="color-option" [class.active]="selectedViewBy === 'inspector'" (click)="onViewBySelect('inspector')">
                Inspector
              </div>
            </div>
          </div>
        </mat-tab>

        <!-- Layers tab -->
        <mat-tab label="Layers">
          <div class="view-tab-content" data-testid="map-layers-tab">
            <div class="layer-options">
              <div class="layer-option" data-testid="map-layer-sites" (click)="onLayerToggle('siteBoundary')">
                <div class="checkbox" [class.checked]="selectedLayers.siteBoundary">
                  @if (selectedLayers.siteBoundary) {
                    <svg class="check-icon" width="10" height="9" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 6.61963L4.62751 10L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  }
                </div>
                <span class="layer-label">Sites</span>
              </div>

              <div class="layer-option" data-testid="map-layer-asbuilts" (click)="onLayerToggle('asBuilt')">
                <div class="checkbox" [class.checked]="selectedLayers.asBuilt">
                  @if (selectedLayers.asBuilt) {
                    <svg class="check-icon" width="10" height="9" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 6.61963L4.62751 10L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  }
                </div>
                <span class="layer-label">As-builts</span>
              </div>

              <div class="layer-option" data-testid="map-layer-pictures" (click)="onLayerToggle('picture')">
                <div class="checkbox" [class.checked]="selectedLayers.picture">
                  @if (selectedLayers.picture) {
                    <svg class="check-icon" width="10" height="9" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 6.61963L4.62751 10L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  }
                </div>
                <span class="layer-label">Pictures</span>
              </div>

              <!-- Label controls -->
              <div class="label-controls-divider"></div>
              <div class="layer-option" data-testid="map-layer-labels" (click)="onToggleLabels()">
                <div class="checkbox" [class.checked]="labelsEnabled">
                  @if (labelsEnabled) {
                    <svg class="check-icon" width="10" height="9" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 6.61963L4.62751 10L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  }
                </div>
                <span class="layer-label">Labels</span>
              </div>
              @if (labelsEnabled) {
                <div class="label-by-selector">
                  <select data-testid="map-label-by-select" (change)="onLabelByChange($any($event.target).value)" [value]="labelBy">
                    <option value="bid_item_name">Bid Item Name</option>
                    <option value="quantity">Quantity</option>
                    <option value="bid_item_code">Item Code</option>
                    <option value="site_name">Site Name</option>
                    <option value="title">Title</option>
                  </select>
                </div>
              }
            </div>
          </div>
        </mat-tab>

        <!-- Types tab -->
        <mat-tab label="Types">
          <div class="view-tab-content">
            <div class="type-options">
              @for (typeFilter of typeFilters; track typeFilter.id) {
                <div class="type-option"
                     (click)="toggleTypeFilter(typeFilter.id)">
                  <div class="checkbox" [class.checked]="isTypeFilterChecked(typeFilter.id)">
                    @if (isTypeFilterChecked(typeFilter.id)) {
                      <svg class="check-icon" width="10" height="9" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 6.61963L4.62751 10L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    }
                  </div>
                  <div class="type-icon-container">
                    <mat-icon [svgIcon]="typeFilter.icon" class="type-icon"></mat-icon>
                  </div>
                  <span class="type-label">{{ typeFilter.label }}</span>
                </div>
              }
              @if (linkedOnlyAvailable) {
                <div class="type-option" data-testid="linked-only-filter" role="checkbox" tabindex="0"
                  [attr.aria-checked]="isTypeFilterChecked(linkedOnlyFilter.id)"
                  (click)="toggleTypeFilter(linkedOnlyFilter.id)"
                  (keydown.enter)="toggleTypeFilter(linkedOnlyFilter.id)"
                  (keydown.space)="$event.preventDefault(); toggleTypeFilter(linkedOnlyFilter.id)">
                  <div class="checkbox" [class.checked]="isTypeFilterChecked(linkedOnlyFilter.id)">
                    @if (isTypeFilterChecked(linkedOnlyFilter.id)) {
                      <svg class="check-icon" width="10" height="9" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 6.61963L4.62751 10L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    }
                  </div>
                  <div class="type-icon-container">
                    <mat-icon [svgIcon]="linkedOnlyFilter.icon" class="type-icon"></mat-icon>
                  </div>
                  <span class="type-label">{{ linkedOnlyFilter.label }}</span>
                </div>
              }
            </div>
          </div>
        </mat-tab>
        <!-- Design tab: the project's design layers (plans, utilities, GIS) next to the SiteNotes layers -->
        @if (showDesignTab) {
        <mat-tab>
          <ng-template mat-tab-label>Design@if (designVisibleCount) {<span class="tab-count">{{ designVisibleCount }}</span>}</ng-template>
          <div class="view-tab-content design-tab" data-testid="map-design-tab">
            @if (hasStationing) {
              <!-- 7.2: station ticks and labels along the project's alignments, and the pointer's station; above the design layers -->
              <div class="layer-options">
                <div class="design-row">
                  <div class="layer-option" data-testid="map-layer-stationing" role="checkbox" tabindex="0" [attr.aria-checked]="stationingOn" aria-label="Stationing"
                       (click)="onToggleStationing()" (keydown.enter)="onToggleStationing()" (keydown.space)="onToggleStationing(); $event.preventDefault()">
                    <div class="checkbox" [class.checked]="stationingOn">
                      @if (stationingOn) {
                        <svg class="check-icon" width="10" height="9" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 6.61963L4.62751 10L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      }
                    </div>
                    <span class="layer-label">Stationing</span>
                  </div>
                </div>
              </div>
            }
            @if (projectLayers.overlayLoading) {
              <p class="design-state" role="status">Loading design layers…</p>
            } @else if (projectLayers.overlayError) {
              <p class="design-state" role="alert">{{ projectLayers.overlayError }}</p>
              <button type="button" class="design-link" (click)="projectLayersRetry.emit()">Try again</button>
            } @else if (!projectLayers.overlayLayers.length) {
              <p class="design-state">No design layers on this project yet.@if (canManageLayers) { Add them in Settings &rsaquo; Design layers. }</p>
            } @else {
              @if (projectLayers.overlayLayers.length > 6) {
                <label class="design-search">
                  <mat-icon aria-hidden="true">search</mat-icon>
                  <input type="search" placeholder="Search layers" aria-label="Search design layers" [value]="designSearch" (input)="setDesignSearch($event)" data-testid="map-design-search" />
                </label>
              }
              <div class="layer-options design-list">
                @for (group of designGroups; track group.name) {
                  @if (group.name !== 'Other layers' || designHasGroups) { <h4 class="design-group-name">{{ group.name }}</h4> }
                  @for (entry of group.entries; track entry.id) {
                    <div class="design-row" [attr.data-layer-id]="entry.id">
                      <div class="layer-option" role="checkbox" tabindex="0" [attr.aria-checked]="isDesignVisible(entry.id)" [attr.aria-label]="entry.name"
                           (click)="projectLayerToggle.emit(entry.id)" (keydown.enter)="projectLayerToggle.emit(entry.id)" (keydown.space)="projectLayerToggle.emit(entry.id); $event.preventDefault()">
                        <div class="checkbox" [class.checked]="isDesignVisible(entry.id)">
                          @if (isDesignVisible(entry.id)) {
                            <svg class="check-icon" width="10" height="9" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1 6.61963L4.62751 10L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          }
                        </div>
                        <span class="layer-label">{{ entry.name }}</span>
                        @if (entry.extent) {
                          <button type="button" class="design-icon" (click)="projectLayerZoom.emit(entry.id); $event.stopPropagation()"
                            [attr.aria-label]="'Zoom to ' + entry.name" [title]="'Zoom to ' + entry.name"><mat-icon>zoom_in_map</mat-icon></button>
                        }
                      </div>
                      @if (entry.drawing; as drawing) {
                        <div class="design-drawing">
                          @if (drawing.needsPlacement) { <span class="design-badge" data-testid="map-design-newer-revision">Newer revision issued</span> }
                          <button type="button" class="design-link" (click)="openDrawingSheet(drawing.revisionUuid)" data-testid="map-design-open-sheet">Open sheet</button>
                        </div>
                      }
                      @if (isDesignVisible(entry.id)) {
                        <label class="design-opacity"><span>Opacity <output>{{ opacityPercent(entry.opacity) }}%</output></span>
                          <input type="range" class="sn-range" min="0" max="100" step="1" [value]="opacityPercent(entry.opacity)" (input)="changeDesignOpacity(entry.id, $event)" [style.--fill]="opacityPercent(entry.opacity) + '%'" [attr.aria-label]="entry.name + ' opacity'" /></label>
                        @if (entry.labels !== undefined) {
                          <label class="design-labels"><input type="checkbox" [checked]="entry.labels" (change)="projectLayerLabels.emit(entry.id)" /> Labels</label>
                        }
                        @if (entry.status === 'loading') { <p class="design-state" role="status">Loading layer…</p> }
                        @if (entry.error) { <p class="design-state" role="alert">{{ entry.error }}</p> }
                      }
                    </div>
                  }
                } @empty { <p class="design-state">No layers match your search.</p> }
              </div>
              <div class="design-actions">
                <button type="button" class="design-link" (click)="projectLayersReset.emit()">Reset to project defaults</button>
                <button type="button" class="design-link" [disabled]="!designVisibleCount"
                  [attr.aria-pressed]="projectLayers.swipePreset === 'project-design-vs-asbuilt'"
                  (click)="projectLayerSwipe.emit(projectLayers.swipePreset === 'project-design-vs-asbuilt' ? 'off' : 'project-design-vs-asbuilt')">
                  {{ projectLayers.swipePreset === 'project-design-vs-asbuilt' ? 'Stop comparison' : 'Swipe to compare' }}
                </button>
              </div>
              @if (projectLayers.swipePreset === 'project-design-vs-asbuilt') {
                <p class="design-note">Drag the divider to compare design layers with SiteNotes records.</p>
              }
              <p class="design-note">Visibility and opacity apply only to your view.</p>
            }
          </div>
        </mat-tab>
        }
      </mat-tab-group>
    </div>
  </ng-template>
</div>
}

<!-- Map-level 3D control: shown while a volume capture is the open bid-item detail -->
@if (volumeFeature3d) {
  <button type="button" class="map-volume-3d-btn" id="map-volume-3d-btn" title="View in 3D"
          aria-label="View volume in 3D" (click)="openVolume3d()">3D</button>
}

<!-- Area summary block — rendered in the normal panel while the polygon tool
     is active, and in place of the bid item detail body when the user draws
     while drilled into an item (the summary is then scoped to that item). -->
<ng-template #spatialSummaryTpl>
      <div class="sidenav-section spatial-summary-section">
        <div class="spatial-summary-header">
          <span class="spatial-summary-title">Area summary</span>
          <div class="spatial-summary-header-right">
            @if (spatialSummaryState.summary) {
              <span class="spatial-summary-subtitle">
                {{ formatSpatialArea(spatialSummaryState.summary.area_acres) }}
              </span>
            }
            @if (spatialSummaryState.summary && !spatialSummaryState.loading) {
              @if (spatialSummaryState.exporting) {
                <mat-spinner class="spatial-summary-export-spinner" color="primary" diameter="18" mode="indeterminate" strokeWidth="3"></mat-spinner>
              } @else {
                <button
                  (click)="exportSpatialSummaryPdf()"
                  class="spatial-summary-export-btn"
                  data-testid="spatial-summary-download-pdf"
                  mat-icon-button
                  matTooltip="Download PDF"
                  matTooltipClass="white-tooltip"
                  type="button"
                >
                  <mat-icon>download</mat-icon>
                </button>
              }
            }
          </div>
        </div>

        @if (spatialSummaryState.exportError) {
          <div class="spatial-summary-state error">{{ spatialSummaryState.exportError }}</div>
        }

        @if (spatialSummaryState.loading) {
          <div class="spatial-summary-state">Loading summary…</div>
        }

        @if (spatialSummaryState.error) {
          <div class="spatial-summary-state error">{{ spatialSummaryState.error }}</div>
        }

        @if (!spatialSummaryState.loading && !spatialSummaryState.error && !spatialSummaryState.summary) {
          <div class="spatial-summary-state">Draw a polygon to see a summary.</div>
        }

        @if (!spatialSummaryState.loading && spatialSummaryState.summary) {
          <div class="spatial-summary-counts">
            <div class="count">
              <span class="count-num">{{ spatialSummaryState.summary.counts.reports }}</span>
              <span class="count-label">reports</span>
            </div>
            <div class="count">
              <span class="count-num">{{ spatialSummaryState.summary.counts.photos }}</span>
              <span class="count-label">photos</span>
            </div>
            <div class="count">
              <span class="count-num">{{ spatialSummaryState.summary.counts.sites }}</span>
              <span class="count-label">sites</span>
            </div>
          </div>

          @if (spatialSummaryState.summary.bid_items.length) {
            <div class="spatial-summary-list-header">
              <span>{{ spatialSummaryState.summary.bid_items.length }} bid {{ spatialSummaryState.summary.bid_items.length === 1 ? 'item' : 'items' }}</span>
            </div>
            <div class="spatial-summary-items">
              @for (bi of spatialSummaryState.summary.bid_items; track bi.bid_item_id) {
                <div class="spatial-summary-item">
                  <div class="spatial-summary-item-row">
                    <span class="spatial-summary-code">{{ bi.item }}</span>
                    <span class="spatial-summary-desc">{{ bi.description | sentenceCase }}</span>
                    <span class="spatial-summary-uom">({{ bi.uom }})</span>
                    <span class="spatial-summary-value">{{ formatSpatialCurrency(bi.total_value) }}</span>
                  </div>
                  <div class="spatial-summary-qty">
                    {{ formatSpatialQty(bi.quantity_in_area) }} {{ bi.uom }}
                    @if (bi.contract_quantity) {
                      of {{ formatSpatialQty(bi.contract_quantity) }}
                      <span class="pct">({{ formatSpatialPct(bi.pct_complete) }})</span>
                    }
                  </div>
                </div>
              }
            </div>
          } @else {
            <div class="spatial-summary-state">No bid items in the drawn area.</div>
          }

          <div class="spatial-summary-total">
            <span>Total contract value in area</span>
            <span class="spatial-summary-total-value">
              {{ formatSpatialCurrency(spatialSummaryState.summary.total_value) }}
            </span>
          </div>
        }
      </div>
</ng-template>
